import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Divider from "../../../components/Divider";
import TwoSections from "../../../components/TwoSections";
import TwoSectionsImages from "../../../components/TwoSectionsImages";
import TwoSectionsAside from "../../../components/TwoSectionsAside";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Column = makeShortcode("Column");
const Aside = makeShortcode("Aside");
const GifPlayer = makeShortcode("GifPlayer");
const Row = makeShortcode("Row");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The interior architecture and design of IBM environments delivers a cohesive experience that unifies our global community and inspires innovation. Our design philosophy and characteristics inform creative decision-making across all dimensions of the design process—from furniture selection to finish palette.`}</p>
    </PageDescription>
    <h2>{`Interior architecture`}</h2>
    <p>{`This guidance provides a framework so that our brand character isn’t only seen but also felt in all our environments. Collectively, both overt and subtle design choices create the connective tissue that supports our culture.`}</p>
    <p>{`IBM workplaces are unified through a principled approach to design and modulated with local context and culture. Design concepts must align with our overarching creative guidance while integrating regional influence. Each of the examples shown here represent different applications of our `}<a parentName="p" {...{
        "href": "/workplace-xg/design-characteristics"
      }}>{`design characteristics`}</a>{` across a variety of design elements. These elements should be developed in consultation with IBM Global Real Estate and IBM Brand teams.`}</p>
    <Divider mdxType="Divider" />
    <TwoSections title="Rhythm and pattern" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Rhythm and pattern are intrinsic to the work of IBM. They are also core components within any expression of interior design or architecture. Application of pattern is limitless, spanning a broad range of design expressions both large and small. Custom IBM patterns use the 2x Grid as a building block. This 2x Grid establishes a common rhythm across all IBM pattern expressions and helps ground our spaces in a unified language.`}</p>
        <p>{`The examples shown here feature different pattern applications that represent a spectrum of scale, materiality, color and dimension. We encourage our design colleagues to explore new expressions of pattern that will enrich the IBM brand.`}</p>
      </Column>
    </TwoSections>
    <TwoSectionsAside className="mt-32" mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`This backsplash concept is inspired by IBM’s `}<a parentName="p" {...{
            "href": "https://www.ibm.com/impact/be-equal/"
          }}>{`Be Equal`}</a>{` program, which utilizes color as a symbol for diversity and inclusion. Textiles and finishes should complement adjacent environmental graphics.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEEAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGzFXYQw//EABsQAAIBBQAAAAAAAAAAAAAAAAIDAQAQERIT/9oACAEBAAEFAmsKXYdSZIl6D1t//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAQMEAwAAAAAAAAAAAAAAAQADIQIQETITMaH/2gAIAQEABj8C424I7W3qBc2RqxN//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARIUFRMf/aAAgBAQABPyFZcG1mzg69ZOgLN0V2e3cu4AfCWz//2gAMAwEAAgADAAAAEFjP/8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQMBAT8Qh//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/EKf/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFhcYGR/9oACAEBAAE/EBaUtwCFV9li2+CA8URYCAIKEGHqKosQrtUY31NMHqNm5//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "backsplash concept",
          "title": "backsplash concept",
          "src": "/workplace-xg/static/9135340b7826991d45f7cfab0552de49/2e753/backsplash-contept.jpg",
          "srcSet": ["/workplace-xg/static/9135340b7826991d45f7cfab0552de49/69549/backsplash-contept.jpg 288w", "/workplace-xg/static/9135340b7826991d45f7cfab0552de49/473e3/backsplash-contept.jpg 576w", "/workplace-xg/static/9135340b7826991d45f7cfab0552de49/2e753/backsplash-contept.jpg 1152w", "/workplace-xg/static/9135340b7826991d45f7cfab0552de49/a052a/backsplash-contept.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`The design of a new headquarters location in Germany employs a vertical facade system that’s reminiscent of our brand identity.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAXPl4w0mK//EABsQAAICAwEAAAAAAAAAAAAAAAECABEQEhMU/9oACAEBAAEFAvRTFxp1fBMsz//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AYj/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQIBAT8BrVP/xAAcEAABAwUAAAAAAAAAAAAAAAAAARAREjFBUeH/2gAIAQEABj8CiknOlOPc/8QAHBABAAIBBQAAAAAAAAAAAAAAAQARMRAhQWGR/9oACAEBAAE/IUIkg8S6IlNodQaErLGzL2f/2gAMAwEAAgADAAAAEMvP/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8QhD//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxBU/8QAHBAAAgICAwAAAAAAAAAAAAAAAREAQSGBMWGR/9oACAEBAAE/EEXYPkdQDP4ARJhcdRpTs3HVXcKY+qf/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Germany headquarters",
          "title": "Germany headquarters",
          "src": "/workplace-xg/static/0bef7399336518c0750842442698001c/2e753/germany-headquarters.jpg",
          "srcSet": ["/workplace-xg/static/0bef7399336518c0750842442698001c/69549/germany-headquarters.jpg 288w", "/workplace-xg/static/0bef7399336518c0750842442698001c/473e3/germany-headquarters.jpg 576w", "/workplace-xg/static/0bef7399336518c0750842442698001c/2e753/germany-headquarters.jpg 1152w", "/workplace-xg/static/0bef7399336518c0750842442698001c/a052a/germany-headquarters.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`This back-lit millwork wall in Costa Mesa adds light and character to the lobby space—reinforcing the linear geometry of the ceiling system.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAQX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABZbOfLpYS/wD/xAAaEAACAwEBAAAAAAAAAAAAAAABAgADERIy/9oACAEBAAEFAmWvBUhlla9N4YZME//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAABAhARIf/aAAgBAQAGPwLUpVwZqr//xAAaEAEBAAMBAQAAAAAAAAAAAAABABEhQTGB/9oACAEBAAE/Ifrvjl2lnawMW4cgfg5ltoX/2gAMAwEAAgADAAAAEEcf/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EByf/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/EGqU/8QAGxABAQADAQEBAAAAAAAAAAAAAREAITFRQWH/2gAIAQEAAT8QVdAbB2/bjFYIovzLaZamAT66e7wgK4aPnMgpKG5n/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Back-lit millwork wall",
          "title": "Back-lit millwork wall",
          "src": "/workplace-xg/static/a48fdce7533a107de5fa8f862ba5cd76/2e753/back-lit-millwork-wall.jpg",
          "srcSet": ["/workplace-xg/static/a48fdce7533a107de5fa8f862ba5cd76/69549/back-lit-millwork-wall.jpg 288w", "/workplace-xg/static/a48fdce7533a107de5fa8f862ba5cd76/473e3/back-lit-millwork-wall.jpg 576w", "/workplace-xg/static/a48fdce7533a107de5fa8f862ba5cd76/2e753/back-lit-millwork-wall.jpg 1152w", "/workplace-xg/static/a48fdce7533a107de5fa8f862ba5cd76/a052a/back-lit-millwork-wall.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <Divider mdxType="Divider" />
    <TwoSections title="Perspective" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Perspective establishes an intentional focal point or points. Interior planning and architecture work together to create moments of alignment that focus visitors along their workplace journey. Shifting perspective can also invite viewers to think, move or interact differently with their environment.`}</p>
        <p>{`Creative use of geometry can challenge perspective as well, reminding us to look at the world in new or provocative ways. Consider how perspective can play a central role in the design and planning of an IBM space.`}</p>
      </Column>
    </TwoSections>
    <TwoSectionsAside className="mt-32" mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`This IBM Watson® activation uses the surrounding architectural geometry of its environment to focus the viewer and frame the composition.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.66666666666666%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABdq4ROkl//8QAGhAAAgIDAAAAAAAAAAAAAAAAAAECEgMRE//aAAgBAQABBQKiZzFFIrNlcoto/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BV//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB8QAAEBCQEAAAAAAAAAAAAAAABBAQMREiEiMTOBov/aAAgBAQAGPwJRTBR5Dhu8lzZj/8QAHhABAAICAQUAAAAAAAAAAAAAAQARIVFBYXGRodH/2gAIAQEAAT8hH2AdFpE849n7AA91jwhquJ1nhKVWN1U//9oADAMBAAIAAwAAABCTD//EABYRAQEBAAAAAAAAAAAAAAAAAAABcf/aAAgBAwEBPxCsP//EABcRAAMBAAAAAAAAAAAAAAAAAAABEWH/2gAIAQIBAT8QUJp//8QAHhABAAIBBAMAAAAAAAAAAAAAAQARITFBUWGBkaH/2gAIAQEAAT8QvE7m0d66+ZWwG5LNu3cGgWsrFfcsG/0CU4zGiaaZ5Z+Cf//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IBM Watson® activation",
          "title": "IBM Watson® activation",
          "src": "/workplace-xg/static/596730013f0e25db2816d475c1fa2605/2e753/watson-activation.jpg",
          "srcSet": ["/workplace-xg/static/596730013f0e25db2816d475c1fa2605/69549/watson-activation.jpg 288w", "/workplace-xg/static/596730013f0e25db2816d475c1fa2605/473e3/watson-activation.jpg 576w", "/workplace-xg/static/596730013f0e25db2816d475c1fa2605/2e753/watson-activation.jpg 1152w", "/workplace-xg/static/596730013f0e25db2816d475c1fa2605/a052a/watson-activation.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`A colorful slatwall challenges perspective as visitors flow around it, creating unique color compositions from every vantage point.`}</p>
      </Aside>
      <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
        <video src="/workplace-xg/2ede328d74bb33f7069bbeccd06f4888/be-equal-slats.mp4" autoPlay="autoplay" loop playsInline muted style={{
          "width": "100%"
        }} />
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAECBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHUVJIP/8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQABBQJf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGhAAAAcAAAAAAAAAAAAAAAAAAAERICFBUf/aAAgBAQABPyEksRrf/9oADAMBAAIAAwAAABA8P//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/EIf/xAAYEAEAAwEAAAAAAAAAAAAAAAABABEgIf/aAAgBAQABPxAI6qBk/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "painted wood slat wall animation with be equal palette",
            "title": "painted wood slat wall animation with be equal palette",
            "src": "/workplace-xg/static/65072561a6dcf5da2dfcebd1eb2c0779/2e753/be-equal-slats.jpg",
            "srcSet": ["/workplace-xg/static/65072561a6dcf5da2dfcebd1eb2c0779/69549/be-equal-slats.jpg 288w", "/workplace-xg/static/65072561a6dcf5da2dfcebd1eb2c0779/473e3/be-equal-slats.jpg 576w", "/workplace-xg/static/65072561a6dcf5da2dfcebd1eb2c0779/2e753/be-equal-slats.jpg 1152w", "/workplace-xg/static/65072561a6dcf5da2dfcebd1eb2c0779/afdee/be-equal-slats.jpg 1357w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </GifPlayer>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`This lobby space employs elements of geometry and pattern to create a dramatic and focused perspective that guides visitors to the IBM reception space.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABgdbMuSKJ/8QAGxAAAQQDAAAAAAAAAAAAAAAAAgABAyERIjL/2gAIAQEAAQUCEtpTfDPQdyWK/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAQUAAAAAAAAAAAAAAAAAEAABESEx/9oACAEBAAY/AnWQbH//xAAZEAEBAQEBAQAAAAAAAAAAAAABABEhMVH/2gAIAQEAAT8hQ+REzvR7aBibbvOpv//aAAwDAQACAAMAAAAQ3/8A/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8QVn//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxACf//EABsQAQADAQADAAAAAAAAAAAAAAEAESExQYGR/9oACAEBAAE/ENaxKPRO50bec5LY6mxjjQK+QgClcZho4YT/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Lobby space",
          "title": "Lobby space",
          "src": "/workplace-xg/static/c1047bd7102f649b2a4c9147563c2925/2e753/lobby-space.jpg",
          "srcSet": ["/workplace-xg/static/c1047bd7102f649b2a4c9147563c2925/69549/lobby-space.jpg 288w", "/workplace-xg/static/c1047bd7102f649b2a4c9147563c2925/473e3/lobby-space.jpg 576w", "/workplace-xg/static/c1047bd7102f649b2a4c9147563c2925/2e753/lobby-space.jpg 1152w", "/workplace-xg/static/c1047bd7102f649b2a4c9147563c2925/a052a/lobby-space.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <Divider mdxType="Divider" />
    <TwoSections title="Geometry" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Geometry establishes a formal relationship between parts and pieces. It informs creative decisions relative to form, volume, proportion and alignment. Using the `}<a parentName="p" {...{
            "href": "https://www.ibm.com/design/language/2x-grid"
          }}>{`2x Grid`}</a>{` as a foundation, we can create repeatable geometries that ground every aspect of our design—from the layout of a floor plan to the sign on a door.`}</p>
        <p>{`While subtle, this relationship creates a familiar cadence within every IBM environment that infuses our brand into the workplace journey.`}</p>
      </Column>
    </TwoSections>
    <TwoSectionsAside className="mt-32" mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`This reception space uses the existing geometry of the building to ground our welcome zone—establishing a relationship between the desk, signage and windows.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABQACBP/EABQBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAWi2cJwyMP8A/8QAGxAAAgEFAAAAAAAAAAAAAAAAAQIAAxAREyH/2gAIAQEAAQUCbE3BmNHsCqLf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAQQDAAAAAAAAAAAAAAAAAAEQESECQVH/2gAIAQEABj8CIjfSmrFEb//EABsQAQEBAAIDAAAAAAAAAAAAAAERABAhMUGh/9oACAEBAAE/ISDtmgExi4V+mQfJvigcf//aAAwDAQACAAMAAAAQF8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAWEQEBAQAAAAAAAAAAAAAAAAABEDH/2gAIAQIBAT8QENJ//8QAGxABAAMBAAMAAAAAAAAAAAAAAQARITEQUXH/2gAIAQEAAT8QMVBa1g+7BWy6sjLLvLnFH6R7lek8f//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Privacy panel",
          "title": "Privacy panel",
          "src": "/workplace-xg/static/2e5c1365fe0fd74874a514aa008e0635/2e753/privacy-panel.jpg",
          "srcSet": ["/workplace-xg/static/2e5c1365fe0fd74874a514aa008e0635/69549/privacy-panel.jpg 288w", "/workplace-xg/static/2e5c1365fe0fd74874a514aa008e0635/473e3/privacy-panel.jpg 576w", "/workplace-xg/static/2e5c1365fe0fd74874a514aa008e0635/2e753/privacy-panel.jpg 1152w", "/workplace-xg/static/2e5c1365fe0fd74874a514aa008e0635/a052a/privacy-panel.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`Our lobby space in Munich contrasts a curvilinear geometry with a rectilinear ceiling grid that adds dynamism and tension to the overall environment.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMCBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHrnTEFSf/EABoQAQEBAAMBAAAAAAAAAAAAAAECAAMRITH/2gAIAQEAAQUC+Z5A015M0vVyo7//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAeEAAABQUBAAAAAAAAAAAAAAAAARARIQIxM1Fxof/aAAgBAQAGPwJj0k3TGXXEU+j/xAAZEAEAAwEBAAAAAAAAAAAAAAABACExEUH/2gAIAQEAAT8hyeA6yq3uARDOEXg035GoUh2FtR//2gAMAwEAAgADAAAAEFs//8QAFhEBAQEAAAAAAAAAAAAAAAAAACEx/9oACAEDAQE/EMV//8QAFREBAQAAAAAAAAAAAAAAAAAAEDH/2gAIAQIBAT8Qp//EAB4QAQADAAEFAQAAAAAAAAAAAAEAESFBMVGRseHw/9oACAEBAAE/EBWgqg6Jx6mKt/jcsCVK1v5Aw1aVAZxKDaqCRrvVQ1Dlag3xP//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Lobby space in Munich",
          "title": "Lobby space in Munich",
          "src": "/workplace-xg/static/96f1ad00c4f1403c207e8e7f3ae2bdf7/2e753/lobby-space-munich.jpg",
          "srcSet": ["/workplace-xg/static/96f1ad00c4f1403c207e8e7f3ae2bdf7/69549/lobby-space-munich.jpg 288w", "/workplace-xg/static/96f1ad00c4f1403c207e8e7f3ae2bdf7/473e3/lobby-space-munich.jpg 576w", "/workplace-xg/static/96f1ad00c4f1403c207e8e7f3ae2bdf7/2e753/lobby-space-munich.jpg 1152w", "/workplace-xg/static/96f1ad00c4f1403c207e8e7f3ae2bdf7/a052a/lobby-space-munich.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`Proportional geometry can also inform many other elements, both large and small, such as furniture or signage. Collectively, they contribute to an overall feeling that’s distinctly IBM.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABepxZKspdEhIA/8QAGRABAAMBAQAAAAAAAAAAAAAAAgEDEgAy/9oACAEBAAEFArrVFm5MHWXJNsznot1yrKT9Ewe//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAgICAgMAAAAAAAAAAAAAAQIAERIhECIxMkH/2gAIAQEABj8CxWKFWyZ28xVw9vsNGgJpoGI2ONCp/8QAGxAAAwEBAQEBAAAAAAAAAAAAAAERITFRYXH/2gAIAQEAAT8huprnB7qX8RklL4N/n6DGRHoJqpore5um2omiktw//9oADAMBAAIAAwAAABB/yP8A/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/ECv/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EGZf/8QAHRABAAICAgMAAAAAAAAAAAAAAQARIUFRgTFhcf/aAAgBAQABPxA8sRYF56jS8arVHLGk3U8Y3R6ima7hBAuGyxVYbnIwEK3CDAiFj8id4SOU/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "proportional geometry examples",
          "title": "proportional geometry examples",
          "src": "/workplace-xg/static/aaffef2409d51e0fbc526799df0c339d/2e753/geometry-examples.jpg",
          "srcSet": ["/workplace-xg/static/aaffef2409d51e0fbc526799df0c339d/69549/geometry-examples.jpg 288w", "/workplace-xg/static/aaffef2409d51e0fbc526799df0c339d/473e3/geometry-examples.jpg 576w", "/workplace-xg/static/aaffef2409d51e0fbc526799df0c339d/2e753/geometry-examples.jpg 1152w", "/workplace-xg/static/aaffef2409d51e0fbc526799df0c339d/a052a/geometry-examples.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <Divider mdxType="Divider" />
    <TwoSections title="Duality" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`IBM has always served as a medium between mankind and machine. This duality manifests in many aspects of our business and design language. Our technical innovation is only matched by the IBM employees and clients who wield it to transform business and society.`}</p>
        <p>{`This relationship often occurs in our design language—hard and soft, organic and engineered, dark and light, positive and negative. These principles can be used to establish tension and dynamism in all aspects of interior architecture—from finishes to fabrics. Biophilic design is another example of duality, bringing elements of nature and the surrounding habitat into the built environment. This outside-in approach is a critical aspect of employee wellness and workplace performance.`}</p>
      </Column>
    </TwoSections>
    <TwoSectionsAside className="mt-32" mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`The Thomas J. Watson Research Center is an early example of biophilic design. Designed by Eero Saarinen in 1961, the building features a stone core made with local materials and a glass facade that maximizes natural light.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB5dUbmcFg/wD/xAAaEAACAwEBAAAAAAAAAAAAAAAAAQIRExID/9oACAEBAAEFAoefRlGmiE+Talsz/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAAIDAQAAAAAAAAAAAAAAAAABEBExwf/aAAgBAQAGPwIfTXFUo//EAB0QAAICAQUAAAAAAAAAAAAAAAABETHBIUFRYXH/2gAIAQEAAT8hkCTVK3bBC8QiuvonZb6ONI//2gAMAwEAAgADAAAAEAzv/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EEoQ/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/ENtX/8QAHBABAQACAgMAAAAAAAAAAAAAAREAITGBQVFx/9oACAEBAAE/EGkIByyvRjhFDTvQwo0+a5Y8reeDZRjtamIaGHq5/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Thomas J. Watson  Research Center",
          "title": "Thomas J. Watson  Research Center",
          "src": "/workplace-xg/static/bc99853c9e472a9e5668bbfc7da1cae0/2e753/thomas-j-watson-research-center.jpg",
          "srcSet": ["/workplace-xg/static/bc99853c9e472a9e5668bbfc7da1cae0/69549/thomas-j-watson-research-center.jpg 288w", "/workplace-xg/static/bc99853c9e472a9e5668bbfc7da1cae0/473e3/thomas-j-watson-research-center.jpg 576w", "/workplace-xg/static/bc99853c9e472a9e5668bbfc7da1cae0/2e753/thomas-j-watson-research-center.jpg 1152w", "/workplace-xg/static/bc99853c9e472a9e5668bbfc7da1cae0/a052a/thomas-j-watson-research-center.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`Duality can also be expressed with thoughtful material contrast. This reception desk integrates a metal hexagonal mesh, inspired by our systems designs, with a natural wood core.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "133.33333333333331%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAQP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAABr3ahQBOM9TUg5H//xAAbEAEAAgIDAAAAAAAAAAAAAAABABECExASMf/aAAgBAQABBQLJCYezSrQSydmbHMqVz//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEj/8QAHRAAAQIHAAAAAAAAAAAAAAAAABARAQIgISIxcf/aAAgBAQAGPwIdL6VzCWPaf//EAB0QAQACAgIDAAAAAAAAAAAAAAEAIRBRMWERQXH/2gAIAQEAAT8hE7hrsY8PU+okr1OyUKaOY20NqJflgNZ//9oADAMBAAIAAwAAABADBE//xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8QZkz/xAAWEQEBAQAAAAAAAAAAAAAAAAAREDH/2gAIAQIBAT8QIHZ//8QAHBABAAMBAAMBAAAAAAAAAAAAAQARMSEQQXFR/9oACAEBAAE/ELDqwjtTiZKjYATtagAYUo+RBxLqSaj5AgiRp5fpfWXSpa+oG6HdgeP/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Material contrast",
          "title": "Material contrast",
          "src": "/workplace-xg/static/29b31a89ac6730c70cb5d1f4297c6d52/2e753/material-contrast-duality.jpg",
          "srcSet": ["/workplace-xg/static/29b31a89ac6730c70cb5d1f4297c6d52/69549/material-contrast-duality.jpg 288w", "/workplace-xg/static/29b31a89ac6730c70cb5d1f4297c6d52/473e3/material-contrast-duality.jpg 576w", "/workplace-xg/static/29b31a89ac6730c70cb5d1f4297c6d52/2e753/material-contrast-duality.jpg 1152w", "/workplace-xg/static/29b31a89ac6730c70cb5d1f4297c6d52/a052a/material-contrast-duality.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`Green elements add an organic contrast to what are traditionally man-made spaces. Plants should be integrated with interior architecture, rather than added as decorative elements.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABn7kdDTA//8QAGhAAAgMBAQAAAAAAAAAAAAAAAAECESEDEv/aAAgBAQABBQKMbPGvHbFLoVZ//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBABAAMBAAAAAAAAAAAAAAAAAAEhMRH/2gAIAQEABj8CTlOKbDX/xAAcEAACAwADAQAAAAAAAAAAAAABEQAhMUFRYXH/2gAIAQEAAT8hZTA3YDTjk9ljpAcgmvsCBVvke5Bz/9oADAMBAAIAAwAAABAQ7//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABYRAQEBAAAAAAAAAAAAAAAAAAEQUf/aAAgBAgEBPxBHZ//EABwQAAICAgMAAAAAAAAAAAAAAAERADEhUZHR4f/aAAgBAQABPxAA8wCZKl3DMjT4oR3BQNJIEWydoLlLbvif/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Green elements contrast",
          "title": "Green elements contrast",
          "src": "/workplace-xg/static/8bee7212c087b85da4a70b12e9a8bfae/2e753/green-elements-contrast.jpg",
          "srcSet": ["/workplace-xg/static/8bee7212c087b85da4a70b12e9a8bfae/69549/green-elements-contrast.jpg 288w", "/workplace-xg/static/8bee7212c087b85da4a70b12e9a8bfae/473e3/green-elements-contrast.jpg 576w", "/workplace-xg/static/8bee7212c087b85da4a70b12e9a8bfae/2e753/green-elements-contrast.jpg 1152w", "/workplace-xg/static/8bee7212c087b85da4a70b12e9a8bfae/a052a/green-elements-contrast.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <TwoSectionsAside mdxType="TwoSectionsAside">
      <Aside mdxType="Aside">
        <p>{`Localized art installations also establish a sense of place and community. While IBM is a global company, we strive to embrace regional influences. Commissioned art is an excellent way to broaden our global ethos and support local culture.`}</p>
      </Aside>
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAGralSeTB//xAAaEAACAwEBAAAAAAAAAAAAAAAAAQIDERIT/9oACAEBAAEFAo2pnSz20VeGSQ4SZ//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/AVf/xAAbEAABBAMAAAAAAAAAAAAAAAAAASEyoRCRsf/aAAgBAQAGPwJHXR0lhksjZ//EABwQAQADAAIDAAAAAAAAAAAAAAEAESExUUFhgf/aAAgBAQABPyGk1N5GlL3psRsb8g9rGzYM8tcw3br1Sf/aAAwDAQACAAMAAAAQTB//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8QkY//xAAXEQEAAwAAAAAAAAAAAAAAAAAAARFR/9oACAECAQE/ELTh/8QAHBABAAICAwEAAAAAAAAAAAAAAREhADFBYYFR/9oACAEBAAE/EFJZ2+N6xZUNQEUvMuLRjWDpQWCfkajByjUu0/S+sgOpaEu2Oc//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "localized wall mural art installation",
          "title": "localized wall mural art installation",
          "src": "/workplace-xg/static/21382dd25af581354e766fa9798f9ae3/2e753/mural-art-installation.jpg",
          "srcSet": ["/workplace-xg/static/21382dd25af581354e766fa9798f9ae3/69549/mural-art-installation.jpg 288w", "/workplace-xg/static/21382dd25af581354e766fa9798f9ae3/473e3/mural-art-installation.jpg 576w", "/workplace-xg/static/21382dd25af581354e766fa9798f9ae3/2e753/mural-art-installation.jpg 1152w", "/workplace-xg/static/21382dd25af581354e766fa9798f9ae3/a052a/mural-art-installation.jpg 1216w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </TwoSectionsAside>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm offsetLg={4} offsetMd={2} mdxType="Column">   
        <ResourceCard subTitle="IBM Workplace Interior Architecture Guide" aspectRatio="2:1" href="https://ibm.ent.box.com/s/alowmrfztm386balqre6rlj9v1c41g27" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      